import { render, staticRenderFns } from "./loading-unloading-fee.vue?vue&type=template&id=09b7112b&scoped=true&"
import script from "./loading-unloading-fee.vue?vue&type=script&lang=js&"
export * from "./loading-unloading-fee.vue?vue&type=script&lang=js&"
import style0 from "./loading-unloading-fee.vue?vue&type=style&index=0&id=09b7112b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b7112b",
  null
  
)

export default component.exports